<!-- 图表 -->
<template>
  <div class="box">
    <tab-list-header
    :list="tabList"
    :cur-index="curIndex"
    @clickTab="clickTab"/>
    <!-- 图表 -->
    <fund-line-chart
      :line-chart-type="curTab.tabValue"
      :fund-code="fundCode"
      :basic-info="basicInfo"
      :detail-info="detailInfo"
      :index-info="indexInfo"
      :period="period"
      @changeAvg="changeAvg"  />
    <!-- 时间选择 -->
    <period-switch-tab :basic-info="basicInfo" @periodChange="periodChange" />

    <!-- 选择弹窗 -->
    <div v-if="showPopup" class="period-popup">
      <div class="popup-container">
        <div v-for="(item, index) in moreTabList" :key="index"
          @click="clickMoreItem(index, item)"
          :class="index === tagCurIndex ? 'cur-more-item' : 'more-item'"
        >{{item.label}}</div>
        <div @click="cancelPopup" class="cancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import TabListHeader from './TabListHeader.vue';
import PeriodSwitchTab from './PeriodSwitchTab.vue';
import FundLineChart from './FundLineChart.vue';

export default {
  name: 'fund-chart-tab',

  components: {
    TabListHeader,
    PeriodSwitchTab,
    FundLineChart,
  },

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    fundType: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    indexInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    basicInfo: {
      handler() {
        if (this.basicInfo?.sellState !== undefined) {
          this.tagCurIndex = [2, 3].includes(this.basicInfo?.sellState) ? 0 : 1;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      showPopup: false,
      tagCurIndex: 0,
      curIndex: 0, // 当前选中tabIndex
      period: 'n', // 当前选中的时间范围
      moreTabList: [
        {
          label: '同类平均',
        },
        {
          label: '在售同类平均',
        },
      ],
    };
  },

  computed: {
    // tab头列表
    tabList() {
      if (this.basicInfo?.isFloatCurrency) {
        return [
          { tabName: '万元收益', tabValue: 'profitOf10000' },
          { tabName: '七日年化', tabValue: 'annualizationOf7D' },
        ];
      }
      if (this.tagCurIndex === 0) {
        return [
          { tabName: '累计收益', tabValue: 'accProfit' },
          { tabName: '单位净值', tabValue: 'perNetValue' },
        ];
      }
      // 浮动货币型不加净值修复
      return [
        { tabName: '累计收益', tabValue: 'accProfit2' },
        { tabName: '单位净值', tabValue: 'perNetValue' },
        // TODO 看时间进度 来得及再做这个
        // { tabName: '净值修复', tabValue: 'netFixed' },
      ];
    },
    curTab() {
      return this.tabList[this.curIndex];
    },

  },

  methods: {
    changeAvg() {
      console.log('changeAvg');
      this.clickMore();
    },

    clickMore() {
      this.showPopup = true;
    },
    cancelPopup() {
      this.showPopup = false;
    },
    clickMoreItem(index, item) {
      this.tagCurIndex = index;
      this.showPopup = false;
      this.$emit('periodChange', { index: index + 4, ...item });
    },
    clickTab(index) {
      this.curIndex = index;
      const { tabValue } = this.curTab;
      const reportMap = {
        accProfit: 'wxgdpzy.sy.ljsy.click',
        accProfit2: 'wxgdpzy.sy.ljsy.click',
        perNetValue: 'wxgdpzy.sy.dwjz.click',
      };
      if (reportMap?.[tabValue]) {
        this.$wxSendTrack(reportMap[tabValue], 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      }
    },

    periodChange(params) {
      this.period = params?.value || this.period;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 12px;
}

.period-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.popup-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
}
.more-item {
  text-align: center;
  line-height: 100px;
  font-size: 32px;
  background-color: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  color: #000000;
}
.cur-more-item {
  text-align: center;
  line-height: 100px;
  font-size: 32px;
  background-color: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  color: #ff4400;
}
.cancel {
  margin-top: 10px;
  background-color: #ffffff;
  text-align: center;
  line-height: 100px;
  font-size: 32px;
}
</style>
